export default "<div class=\"wrapper\">\n    <app-masterpage></app-masterpage>\n    <div id=\"content\">\n        fdsghsgd\n    </div>\n</div>"